import '../../pages/Create/Create.css';
import './Panel.css';

import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';

  

const CreatePostPanel = ({ onClose }) => {

const navigate = useNavigate();
  
  const {token, setToken} = useContext(AppContext);
  
  const [formData, setFormData] = useState({
              post:'',
              media: '',
      });
          
  const [errors, setErrors] = useState({}); 

  
  const [serverMessage, setServerMessage] = useState(''); 
          
          
  const [preview, setPreview] = useState(null);

  const handleChanges = (e) => {
    //  const f = e.target.files[0]; // Get the first selected file
    //   setSelectedImage(f);

    const { name, value, files } = e.target;

    if (name === "media") {
      console.log('ss');
    
      const file = files[0];
      setFormData({ ...formData, media: file });

      if (file) {
        setPreview(URL.createObjectURL(file));
      } else {
        setPreview(null);
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
          
          
    const handleSubmit = async (e) => {
      e.preventDefault();
      
      // console.log(...formData);
      console.log(token);

      if(token == null){
        navigate('/login');
        return ;
      }

      setErrors({}); 


        console.log("formData.media:", formData.media.name);

        
        console.log("formData.media:", formData.media);


        console.log(formData);
        console.log('11111111111');

        const formToApi = new FormData();
        formToApi.append("post", formData.post);
        formToApi.append("media", formData.media);   
        
        // formToApi.append('image', selectedImage); // 'image' is the field name for the backend


        console.log(formToApi);
        
              
        const response = await fetch('https://dashboard.tiktaka.com/api/post', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,  
            'Accept': 'application/json',
          },
          body: formToApi
        });
  
        const data = await response.json();
  
        console.log(data);

        // setServerMessage(data.message);
  
        if (response.ok) {
              alert("✅ تم التسجيل بنجاح!");
              console.log(data);
              setServerMessage(data.message);
              
      
          } else if (response.status === 422) {
              setErrors(data.errors);
          } else {
              console.log(data.message);
          }
  
    };
  

  return (

    <div className="modal-panel">
      <div className="panel-header">
        <h2>Create Post</h2>
        <button onClick={onClose}>✖</button>
      </div>
      <div className="panel-body">

            <form onSubmit={handleSubmit} className='material-form'>

                        {serverMessage && (
                          <div style={{ color: "red", marginBottom: "10px" }}>
                            {serverMessage}
                          </div>
                        )}

                        <div className='input-field'>
                            <input type='text' placeholder='title' name='post' value={formData.post}
                                    onChange={handleChanges} ></input>
                            <label>Title</label>
                            <span className="bar"></span>


                            {errors.post && (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                    {errors.post[0]}
                                    </div>
                            )}
                        </div>
                        <div className='input-field'>

                          <input
                            type='file'
                            accept='image/*,video/*'
                            name='media'
                            onChange={handleChanges}
                          />

                           <label>Upload</label>
                          <span className="bar"></span>

                          {errors.media && (
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {errors.media[0]}
                            </div>
                          )}
                        </div>
                      

                          {preview && (
                              <div style={{ marginTop: '10px' }}>
                                {formData.media.type.startsWith("image") ? (
                                  <img src={preview} alt="preview" style={{ maxWidth: '200px' }} />
                                ) : (
                                  <video src={preview} controls style={{ maxWidth: '200px' }} />
                                )}
                              </div>
                            )}



                        <button type='submit'>Create</button>
                  </form>

      </div>
    </div>
  );


};


export default CreatePostPanel;
